import { ProtectedRoute } from '@shared/auth';
import { Outlet } from 'react-router';

const ClientsLayout = () => {
  return <ProtectedRoute component={Outlet} policies={['isAnyArtiaUser']}/>;
};

export default ClientsLayout;
